export default "__VITE_ASSET__BjCTJDXP__"